'use client';

import type { FC } from 'react';
import { Credits } from '../../components/Credits';
import { Skeleton } from '../../components/ui';

interface PrizeRangeBarProps {
  lo: number;
  hi: number;
  price: number;
  needleLeft: number;
  animating: boolean;
  loading: boolean;
  labels: { min: string; yourItems: string; max: string };
}

export const PrizeRangeBar: FC<PrizeRangeBarProps> = ({
  lo,
  hi,
  price,
  needleLeft,
  animating,
  loading,
  labels,
}) => {
  return (
    <div className="w-full max-w-[420px] px-4">
      <div className="bg-white/3 border border-[rgba(59,130,246,0.15)] rounded-2xl px-5 py-3 min-h-16 flex items-center">
        <div className="w-full">
          {/* WHY: боковые колонки равной ширины — иначе скелет вместо числа сдвигает стоимость по центру */}
          <div className="grid grid-cols-[1fr_auto_1fr] items-end mb-2">
            <div className="flex flex-col items-start">
              <span className="text-[10px] text-error uppercase tracking-[0.05em]">{labels.min}</span>
              {loading ? (
                <Skeleton className="my-0.5 h-4 w-16 rounded-full" />
              ) : (
                <span className="text-sm font-bold text-slate-100"><Credits amount={lo} /></span>
              )}
            </div>
            <div className="flex flex-col items-center px-3">
              <span className="text-[10px] text-white/45 uppercase tracking-[0.05em]">{labels.yourItems}</span>
              <span className="text-base font-extrabold text-white"><Credits amount={price} /></span>
            </div>
            <div className="flex flex-col items-end">
              <span className="text-[10px] text-success uppercase tracking-[0.05em]">{labels.max}</span>
              {loading ? (
                <Skeleton className="my-0.5 h-4 w-16 rounded-full" />
              ) : (
                <span className="text-sm font-bold text-slate-100"><Credits amount={hi} /></span>
              )}
            </div>
          </div>
          <div
            className="relative"
            style={{ height: 8, borderRadius: 9999, background: 'linear-gradient(90deg,#ef4444 0%,#3b82f6 50%,#22c55e 100%)' }}
          >
            <div
              style={{
                position: 'absolute',
                left: `${needleLeft * 100}%`,
                top: -11,
                transform: 'translateX(-50%)',
                transition: animating ? 'none' : 'left 300ms ease',
              }}
            >
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderLeft: '7px solid transparent',
                  borderRight: '7px solid transparent',
                  borderTop: '11px solid #fff',
                  filter: 'drop-shadow(0 0 6px rgba(255,255,255,0.9))',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
